module.exports = __webpack_public_path__ + "static/Q2Answer_foundingchildren_wishmastree-e3feaa2e62d2fb4b8e9333831a9fdd4d.jpg";